import "./cspNonce";

// This overrides the default bootstrap alert hide which normally adds "display:none"
// to the element. This takes off the "show" class and adds the "hide" class
$(".alert").on("close.bs.alert", function () {
  $(this).removeClass("show").addClass("hide");
  return false;
});

// this snippet of code finds the ancestor of the current item
// directly under home and sets that nav menu item as active if it exists
var siteNav = $("nav.siteNav");
var tertiaryNav = $("nav.siteHeaderActions");
var ancestorUnderHome = $("#hidAncestorUnderHome");

if (
  siteNav.length > 0 ||
  (tertiaryNav.length > 0 && ancestorUnderHome.length > 0)
) {
  var navLink = siteNav.find(`a[href='${ancestorUnderHome.val()}']`);
  var tertLink = tertiaryNav.find(`a[href='${ancestorUnderHome.val()}']`);
  if (navLink.length > 0) {
    navLink.parent().addClass("active");
  }
  if (tertLink.length > 0) {
    tertLink.parent().addClass("active");
  }
}

$(document).on("click", "button.close", function (e) {
  let tag = e.target;
  if (e.target.tagName.toLowerCase() === "i") {
    tag = e.target.parentElement;
  }
  const expiresDate = new Date();
  const expiresDays = parseInt(tag.dataset["cookieDays"]);
  expiresDate.setDate(expiresDate.getDate() + expiresDays);
  document.cookie = `${tag.dataset["cookieName"]}=; expires=${expiresDate.toUTCString()}; path=/; secure; samesite=none`;
});
